import { MenuItem } from './menu.model';

// export const MENU: MenuItem[] = [

//     {
//         id: 1,
//         label: 'Dashboards',
//         icon: '',
//         subItems: [
//             {
//                 id: 2,
//                 label: 'LPC',
//                 link: '/lpc-dashboard',
//                 parentId: 1
//             },
//             {
//                 id: 3,
//                 label: 'Timekeeper',
//                 link: '/timekeeper-dashboard',
//                 parentId: 1
//             },
//         ]
//     },

//     {
//         id: 2,
//         label: 'Organizations',
//         icon: '',
//         link: '/organization',
       
//     },
//     {
//         id: 3,
//         label: 'Matters',
//         link: '/matters',
//     },
//     {
//         id: 4,
//         label: 'Projects',
//         link: '/projects',

//     },
    
   
//     {
//         id: 5,
//         label: 'Tasks',
//         icon: '',
//         link:'/task-grid'
//     },
//     {
//         id: 5,
//         label: 'TK Availability',
//         icon: '',
//         link:'/tk-availability'
//     },
//     {
//         id: 5,
//         label: 'Time Records',
//         icon: '',
//         link:'/time-record'
//     },
//     {
//         id: 6,
//         label: 'Admin',
//         icon: '',
//         subItems: [
//             {
//                 id: 7,
//                 label: 'Users',
//                 link: '/user-grid',
//                 parentId: 6
//             },
//             // {
//             //     id: 8,
//             //     label: 'TK Availability',
//             //     link: '/tk-availability',
//             //     parentId: 6
//             // },
//             {
//                 id: 9,
//                 label: 'Task Catalog',
//                 link: '/task-catalogue',
//                 parentId: 6
//             },
//             {
//                 id: 10,
//                 label: 'Projects Templates',
//                 link: '/projects-template',
//                 parentId: 6
//             },
//             {
//                 id: 11,
//                 label: 'Import Data',
//                 link: '/import-data',
//                 parentId: 6
//             },
//             {
//                 id: 12,
//                 label: 'Time Record Export',
//                 link: '/timerecord-export',
//                 parentId: 6
//             },
//             {
//                 id: 13,
//                 label: 'Application Configurations',
//                 link: '/app-config',
//                 parentId: 6
//             },
//             {
//                 id: 14,
//                 label: 'Time Approver Rules',
//                 link: '/time-approver-rules',
//                 parentId: 6
//             }
//         ]
       
//     },
//     {
//         id: 14,
//         label: 'Reports',
//         icon: '',
//         subItems: [
//             {
//                 id: 15,
//                 label: 'Payroll Time Report',
//                 link: '/payroll-time-report',
//                 parentId: 14
//             },
//             {
//                 id: 16,
//                 label: 'Client Time Report',
//                 link: '/client-time-report',
//                 parentId: 14
//             },
//         ]
       
//     },
   
// ];


export const MENU: MenuItem[] = [
    // {
    //   id: 1,
    //   label: 'Dashboards',
    //   icon: '',
    //   subItems: [
    //     {
    //       id: 2,
    //       label: 'LPC',
    //       link: '/lpc-dashboard',
    //       parentId: 1,
    //       roles: ['LPC', 'ADMIN'] // only visible to LPC and ADMIN roles
    //     },
    //     {
    //       id: 3,
    //       label: 'Timekeeper',
    //       link: '/timekeeper-dashboard',
    //       parentId: 1,
    //       roles: ['TK', 'ADMIN'] // only visible to TK and ADMIN roles
    //     },
    //   ],
    //   roles: ['LPC', 'TK', 'ADMIN'] // only visible to LPC, TK, and ADMIN roles
    // },
    {
      id: 1,
      label: 'Dashboard',
      icon: '',
      link: '/dashboard',
      roles: ['LPC', 'TK','ADMIN'] 
    },
    {
      id: 2,
      label: 'Organizations',
      icon: '',
      link: '/organization',
      roles: ['LPC','ADMIN'] // only visible to LPC, TK, Billing and ADMIN roles
    },
    {
      id: 3,
      label: 'Matters',
      link: '/matters',
      roles: ['LPC','ADMIN'] // only visible to LPC, TK, Billing and ADMIN roles
    },
    {
      id: 4,
      label: 'Projects',
      link: '/projects',
      roles: ['LPC', 'TK', 'ADMIN','Billing'] // only visible to LPC, TK, Billing and ADMIN roles
    },
    {
      id: 5,
      label: 'Tasks',
      icon: '',
      link: '/task-grid',
      roles: ['LPC', 'TK', 'ADMIN','Billing'] // only visible to LPC, TK, Billing and ADMIN roles
    },
    
    {
      id: 5,
      label: 'TK Availability',
      icon: '',
      link: '/tk-availability',
      roles: ['TK', 'ADMIN'] // only visible to TK and ADMIN roles
    },
    {
      id: 5,
      label: 'Time Records',
      icon: '',
      link: '/time-record',
      roles: ['LPC', 'TK', 'ADMIN'] // only visible to LPC, TK, and ADMIN roles
    },
    {
      id: 5.5,
      label: 'Entities',
      link: '/entities',
      roles: ['LPC', 'ADMIN','Billing'] // only visible to LPC, Billing and ADMIN roles (not TK only)
    },
    {
      id: 6,
      label: 'Admin',
      icon: '',
      subItems: [
        {
          id: 7,
          label: 'Users',
          link: '/user-grid',
          parentId: 6,
          roles: ['ADMIN'] // only visible to ADMIN role
        },
        {
          id: 9,
          label: 'Task Catalog',
          link: '/task-catalogue',
          parentId: 6,
          roles: ['ADMIN'] // only visible to ADMIN role
        },
        {
          id: 10,
          label: 'Projects Templates',
          link: '/projects-template',
          parentId: 6,
          roles: ['ADMIN'] // only visible to ADMIN role
        },
        {
          id: 11,
          label: 'Import Data',
          link: '/import-data',
          parentId: 6,
          roles: ['ADMIN','Finance'] // only visible to ADMIN role
        },
        // {
        //   id: 12,
        //   label: 'Time Record Export',
        //   link: '/timerecord-export',
        //   parentId: 6,
        //   roles: ['ADMIN'] // only visible to ADMIN role
        // },
        {
          id: 13,
          label: 'Application Configurations',
          link: '/app-config',
          parentId: 6,
          roles: ['ADMIN',"Finance"] // only visible to ADMIN role
        },
        {
          id: 14,
          label: 'Time Approver Rules',
          link: '/time-approver-rules',
          parentId: 6,
          roles: ['ADMIN'] // only visible to ADMIN role
        },
        {
          id: 17,
          label: 'Payment Method Settings',
          link: '/payment-method-settings',
          parentId: 6,
          roles: ['ADMIN','Finance'] // only visible to ADMIN role
        },
        {
          id: 18,
          label: 'Escrow Accounts',
          link: '/escrow-accounts',
          parentId: 6,
          roles: ['ADMIN','Finance'] // only visible to ADMIN role
        },
        {
          id: 19,
          label: 'Vendors',
          link: '/vendors',
          parentId: 6,
          roles: ['ADMIN','Finance'] // only visible to ADMIN role
        },
        {
          id: 19,
          label: 'Informational Text',
          link: '/field-info-grid',
          parentId: 6,
          roles: ['ADMIN'] // only visible to ADMIN role
        },
        {
          id: 20,
          label: 'Contacts',
          link: '/contacts-grid',
          parentId: 6,
          roles: ['ADMIN'] // only visible to ADMIN role
        }
      ],
      roles: ['ADMIN','Finance'] // only visible to ADMIN role
    },
    {
      id: 14,
      label: 'Reports',
      icon: '',
      subItems: [
        {
          id: 15,
          label: 'Payroll Time Report',
          link: '/payroll-time-report',
          parentId: 14,
          roles: [ 'ADMIN','Reporting'] //only visible to LPC and ADMIN roles
        },
        {
          id: 16,
          label: 'Client Time Report',
          link: '/client-time-report',
          parentId: 14,
          roles: [ 'ADMIN','Reporting'] // only visible to LPC and ADMIN roles
        },  
      ],
      roles: [ 'ADMIN','Reporting'] // only visible to LPC and ADMIN roles
    },
    {
      id: 17,
      label: 'Exports',
      icon: '',
      subItems: [
        {
          id: 18,
          label: 'Time Records',
          link: '/timerecord-export',
          parentId: 17,
          roles: [ 'ADMIN','Finance'] //only visible to LPC and ADMIN roles
        },
        {
          id: 19,
          label: 'Disbursements',
          link: '/disbursements-export',
          parentId: 17,
          roles: [ 'ADMIN','Finance'] // only visible to LPC and ADMIN roles
        },
      ],
      roles: [ 'ADMIN','Finance'] // only visible to LPC and ADMIN roles
    },
  ];